import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { initWebSocketListeners } from "./scheduleApiOrchestrator";

initWebSocketListeners();

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/index.js